import OrderSummary from '@/components/Cart/OrderSummary'

import { Button } from '../components/ui/button'
import { useNavigate } from 'react-router'
import { useAuth } from '@/hooks/useAuth'
import { createSearchParams } from 'react-router-dom'
import useCartStore from '@/store/cart'
// import { RAILS_ENV } from '@/lib/constants'

function CheckoutButton({ checkout }: { checkout: () => void }) {
  // if (RAILS_ENV !== 'production') {
  return (
    <Button
      type="button"
      className="w-full text-base font-medium text-white hover:bg-blue-800"
      onClick={checkout}
      variant="default"
    >
      Checkout
    </Button>
  )
  // } else {
  //   return (
  //     <Button
  //       type="button"
  //       className="w-full text-base font-medium text-white"
  //       variant="secondary"
  //       disabled
  //     >
  //       Checkout will be enabled soon!
  //     </Button>
  //   )
  // }
}

function Cart() {
  const navigate = useNavigate()
  const { isAuthenticated } = useAuth()

  const { cartItems } = useCartStore()

  const checkout = () => {
    if (isAuthenticated()) {
      navigate('/checkout')
    } else {
      navigate({
        pathname: '/signin',
        search: createSearchParams({ return_path: '/checkout' }).toString(),
      })
    }
  }

  return (
    <div className="flex items-center justify-center flex-col main-container-height">
      <h1 className="text-3xl">Cart</h1>
      <div className="flex justify-center">
        <OrderSummary>
          <div className="flex gap-x-2">
            <Button
              type="button"
              className="w-full text-base font-medium text-white"
              variant="secondary"
              onClick={() => navigate('/')}
            >
              Continue Shopping
            </Button>
            {cartItems.length > 0 && <CheckoutButton checkout={checkout} />}
          </div>
        </OrderSummary>
      </div>
    </div>
  )
}

export default Cart